import { useState } from 'react';
import { AlertTriangle, ChevronDown } from 'lucide-react';
import type { AlertEntry } from '../types';

const SEVERITY_BG: Record<string, string> = {
  Extreme: 'bg-red-950/80 border-red-400/60',
  Severe: 'bg-red-900/70 border-red-500/50',
  Moderate: 'bg-amber-900/60 border-amber-500/50',
  Minor: 'bg-yellow-900/50 border-yellow-500/40',
};

export default function AlertsBanner({ alerts }: { alerts: AlertEntry[] }) {
  const [openId, setOpenId] = useState<string | null>(null);
  return (
    <div className="space-y-2">
      {alerts.map((a) => {
        const isOpen = openId === a.id;
        const tone = SEVERITY_BG[a.severity] ?? SEVERITY_BG.Moderate;
        return (
          <div key={a.id} className={`border rounded-lg ${tone}`}>
            <button
              onClick={() => setOpenId(isOpen ? null : a.id)}
              className="flex items-start gap-3 w-full text-left p-3"
            >
              <AlertTriangle className="w-5 h-5 shrink-0 mt-0.5" />
              <div className="flex-1">
                <div className="font-medium text-sm">{a.event}</div>
                <div className="text-xs opacity-90">{a.headline}</div>
              </div>
              <ChevronDown
                className={`w-4 h-4 shrink-0 mt-1 transition-transform ${isOpen ? 'rotate-180' : ''}`}
              />
            </button>
            {isOpen && (
              <div className="px-3 pb-3 text-xs opacity-90 whitespace-pre-wrap">
                {a.description}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
